import React from 'react';
import PropTypes from 'prop-types';

import List from '../../helpers/List';

import EbookForm from './EbookForm';

const EbookContent = ({
    t, openPage, language, breakpoint, scrollToForm, ebook, consents
}) => (
    <div className="container-ebook-content" id="container-ebook-content">
        <div className="layout">
            <div className="page-ebook-content" id="page-ebook-content">
                <div className="ebook-content" id="ebook-content">
                    <div className="ebook-content-title" id="ebook-content-title">{ ebook.content.title }</div>
                    <ul
                      className="ebook-content-list"
                      onClick={ scrollToForm }
                    >
                        {
                            (breakpoint === 'widescreen' || breakpoint === 'desktop' || breakpoint === 'laptop') &&
                                <span className="tooltip">{ t('ebook.tooltip') }</span>
                        }
                        <List data={ ebook.content.list }/>
                    </ul>
                </div>
                <EbookForm
                  t={ t }
                  openPage={ openPage }
                  language={ language }
                  ebook={ ebook }
                  consents={ consents }
                />
            </div>
        </div>
    </div>
);

EbookContent.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    breakpoint: PropTypes.string.isRequired,
    scrollToForm: PropTypes.func.isRequired,
    ebook: PropTypes.shape().isRequired,
    consents: PropTypes.objectOf(Object).isRequired
};

export default EbookContent;



// WEBPACK FOOTER //
// ./src/components/content/ebook/EbookContent.jsx